/**
 * Created by zad on 18/1/2.
 */
import React from 'react';
import _ from 'lodash';

const attributeMap = {
  class: 'className',
  for: 'htmlFor',
};

const convertCSS2JS = (css) => {
  const frameCSS = css.replace(/;+$/, '');
  const properties = frameCSS.split(';');
  const result = {};

  properties.forEach((property) => {
    const cssProp = property.split(':');
    const cssKey = _.camelCase(cssProp[0]);
    result[cssKey] = cssProp[1].trim();
  });
  return result;
};

const nodeMapToObject = (nodeMap) => {
  const result = {};
  for (let i = 0; i < nodeMap.length; i++) {
    const attr = nodeMap[i];
    const { name } = attr;
    if (name === 'style') {
      result.style = convertCSS2JS(attr.value);
    } else if (attributeMap[name]) {
      result[attributeMap[name]] = attr.value;
    } else if (/^(data|aria)-/.test(name)) {
      result[name] = attr.value;
    } else if (!/^on.*/.test(name)) {
      // 如果取到的value为空字符串，则说明是bool值，显示的设置为true
      result[_.camelCase(name)] = attr.value === '' ? true : attr.value;
    }
  }
  return result;
};

const nodeListToArray = (nodeList) => {
  const nodes = [];

  [].forEach.call(nodeList, (child) => {
    const node = {};
    const { childNodes, nodeType, nodeName, nodeValue } = child;
    node.type = nodeName.toLowerCase();
    // text
    if (nodeType === 3) {
      node.type = 'text';
      node.value = nodeValue;
    }
    if (nodeType === 1 && child.hasAttributes()) {
      const { attributes } = child;
      node.attr = nodeMapToObject(attributes);
    }
    if (childNodes.length) {
      node.children = nodeListToArray(childNodes);
    }
    nodes.push(node);
  });

  return nodes;
};

const toReactElement = (node, key) => {
  const { childNodes, nodeType, nodeName, nodeValue, attributes } = node;

  if (nodeType === 3) {
    return nodeValue;
  }
  if (nodeType === 1) {
    const type = nodeName.toLowerCase();
    const props = { key };
    if (node.hasAttributes()) {
      Object.assign(props, nodeMapToObject(attributes));
    }
    let children = _.toArray(childNodes).map((child, index) => toReactElement(child, `${key}-${index}`));
    if (children.length === 0) {
      children = null;
    }
    return React.createElement(type, props, children);
  }
  return null;
};

export function getVNodes(html) {
  const div = document.createElement('div');
  div.innerHTML = html;
  return nodeListToArray(div.childNodes);
}

// 将html转成React.Element
export function getReactElements(html) {
  const div = document.createElement('div');
  div.innerHTML = html;

  const elements = _.toArray(div.childNodes)
    .map((childNode, index) => toReactElement(childNode, `code-${index}`))
    .filter(element => element !== null);

  if (elements.length === 1) {
    return elements[0];
  }
  return elements;
}



// WEBPACK FOOTER //
// ./src/utils/vdom.js